import gql from 'graphql-tag';

export const getFormBse = gql`
  query getFormBSE($requestId: Float!) {
    procedures {
      formBSE(filters: { operationNumber: $requestId }) {
        fields {
          id
          description
          type
          value
          dropDownList {
            id
            description
          }
        }
        documents {
          id
          name
          originalName
          path
          idType
          type
          size
        }
        tokenDrop
      }
    }
  }
`;

export const registerBse = gql`
  mutation register(
    $operationNumber: Float!
    $origin: String!
    $UT: Boolean
    $fields: [FieldFormToBSE!]!
  ) {
    saveFormBSE(
      parameters: {
        operationNumber: $operationNumber
        origin: $origin
        fields: $fields
        UT: $UT
      }
    ) {
      status
      operationNumber
    }
  }
`;

export const activatePayOrder = gql`
  mutation activatePayOrderScholarshipSocioEconomic(
    $operationNumber: Float!
    $origin: String!
  ) {
    activatePayOrderScholarshipSocioEconomic(
      operationNumber: $operationNumber
      origin: $origin
    ) {
      status
      data
      message
    }
  }
`;

export const processBse = gql`
  mutation processRequestBse($idRequest: String!, $test: Boolean) {
    requestProcessBSE(params: { idRequest: $idRequest, test: $test }) {
      status
      data {
        statusDesc
        idRequest
      }
      message
    }
  }
`;

export const getBseDocument = gql`
  query getFormBSE($requestId: Float!) {
    procedures {
      formBSE(filters: { operationNumber: $requestId }) {
        documents {
          id
          idConcept: idType
          originalFileName: originalName
          path
          size
        }
      }
    }
  }
`;

export const uploadBseDocument = gql`
  mutation requestDocumentUpload(
    $base64: String!
    $fileName: String!
    $idConcept: String!
    $idRequest: String!
    $originalFileName: String!
  ) {
    requestDocumentUpload(
      params: {
        base64: $base64
        fileName: $fileName
        idConcept: $idConcept
        idRequest: $idRequest
        originalFileName: $originalFileName
        test: false
      }
    ) {
      status
      message
      data {
        statusDesc
        idFile
        linkDrop
      }
    }
  }
`;

export const deleteFileBse = gql`
  mutation requestDocumentDelete($idFile: Float!) {
    requestDocumentDelete(params: { idFile: $idFile }) {
      status
      message
      data
    }
  }
`;

export const getStateBse = gql`
  query getProceduresEvaluationScholarshipSocioEconomic(
    $idProcedure: Float!
    $operationNumber: Float!
  ) {
    student {
      proceduresEvaluationScholarshipSocioEconomicDetail(
        filters: {
          idProcedure: $idProcedure
          operationNumber: $operationNumber
        }
      ) {
        commentary
        dateRequest
        dateFinalized
        discount
        sendDate
        expirationDate
        isLastAttempt
      }
    }
  }
`;
